import { Card, Row, message } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const FilebrowserData = ({ appName }) => {
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        HTTPClient.get("/appcustomizations/filebrowser/get_data/" + appName)
            .then((res) => {
                setUsername(res.data.username);
                setPassword(res.data.password);
            })
            .catch((e) => {
                message.error(t("dettaglio_app.file_browser.error"));
            });
    }, []);

    return (
        <Card title="Dati" style={{ width: "100%", marginTop: "15px" }}>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                {t("dettaglio_app.file_browser.info")}
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <p>Username: {username}</p>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <p>Password: {password}</p>
            </Row>
        </Card>
    );
};

export { FilebrowserData };
